import { AppBar, Box, Container, Slide, Toolbar } from "@mui/material";
import { useLayoutEffect, useState } from "react";

import Logo from "../../../components/Logo";
import NavList from "../NavList";
import NavMenu from "../NavMenu";

import useEventListener from "../../../hooks/useEventListener";
import useScrollPosition from "../../../hooks/useScrollPosition";
import { appBar, glass, theme } from "../../../utils/theme";

import { styles } from "./style";

const Nav = ({ contained }) => {
  const { ref: rootRef, scrollPosition: posY } = useScrollPosition();
  const [showToolbar, setShowToolbar] = useState(true);
  const [windowHeight, setWindowHeight] = useState(null);

  useLayoutEffect(() => {
    setWindowHeight(window.innerHeight * 0.4);
  }, []);

  const handleScroll = () => {
    setShowToolbar(window.scrollY <= appBar.height);
  };

  useEventListener("scroll", handleScroll);

  return (
    <Box ref={rootRef}>
      <AppBar
        elevation={0}
        sx={
          contained
            ? {
                ...styles.navRoot,
                background: glass.background,
                color: theme.palette.grays.black,
                backdropFilter: glass.backdropFilter,
              }
            : {
                ...styles.navRoot,
                // transform: !showToolbar ? `translateY(-${appBar.height}px)` : "",
                background: !showToolbar ? glass.background : "transparent",
                color: !showToolbar
                  ? theme.palette.grays.black
                  : theme.palette.grays.white,
                // borderBottomWidth: !showToolbar ? 1 : 0,
                backdropFilter: !showToolbar ? glass.backdropFilter : "none",
              }
        }
      >
        <Container maxWidth="xl">
          <Toolbar sx={styles.toolbar}>
            <Logo
              lightTheme={contained ? false : !showToolbar ? false : true}
            />

            <NavList />

            <NavMenu />
          </Toolbar>
        </Container>
      </AppBar>
    </Box>
  );
};

export default Nav;
